<script>
    import { onMount } from 'svelte';
    import { fade, fly } from 'svelte/transition';
    import { ServerRequest } from '../service/ServerRequest.js';
    import { AppAccessGranted ,UserToken, UserData } from '../stores/LoggedUser.js';
    import { EventSelected } from '../stores/EventSelected';
    import { logout } from '../service/PersistStore.js';
    import FloatMenu from '../components/FloatMenu.svelte';

    let token = $UserToken;
    let menu_open = false;
    let showPanel = false;

    onMount(  () => {
        console.log($UserToken);
        console.log($UserData);
        if( $AppAccessGranted != 'true' || $UserToken == '' ){
            logout();
        }

        // when on this page rest selected event
        EventSelected.set({});
        const wait = setTimeout(() => {
            showPanel = true;
            clearTimeout(wait);
        }, 525);
        loadEvents();
    })

    let next_events = [];
    let passt_events = [];

    function loadEvents() {
        
        ServerRequest.get(ServerRequest.routes.events, token, {})
        .then( (resp) => {
            console.log(resp);
            if (resp.status && resp.data) {
                for( let event of resp.data ){
                    console.log(event);
                    if( event.active == 1 || event.active == '1' ){
                        next_events = [...next_events, event];
                    } else {
                        passt_events = [...passt_events, event];
                    }
                }
            }
        });
    }

    function setEvent( ev ) {
        EventSelected.set(ev);
        window.location.href = '#/event_detaile';
    }

</script>

{#if showPanel}
<main class="rpgui-content rpgui-cursor-default" 
    in:fly={{ x: -400, duration: 500 }}
    out:fly={{ x: -400, duration: 500 }}
    >
    <div class="main-page-container rpgui-container framed">
        <h1 class="t-20">Eventi</h1>
        <div class="main-page-content">
            <div class="current-events mb-4">
                <h4 class="t-12 coral-text-color border-buttom-coral no_decoration text-left">Prossimo evento</h4>
                <div>
                    {#each next_events as event }
                        <div style="background:#575e46; padding: 1rem; margin-top: .5rem; border-radius: .25rem; position:relative;" 
                            in:fade="{{ duration: 120 }}"
                            on:click="{ () => setEvent(event) }"
                            >
                            <h5 class="t-12" style="color:#f4be8b;margin: 0 0 1rem 0;">&#9654; {event.title ? event.title : ''} &#9664;</h5>
                            <div>
                                <p class="t-10" style="font-size:14px; word-break: break-all; ">{event.short_description ? event.short_description : ''}</p>
                            </div>
                        </div>						
				    {/each}
                </div>
            </div>
            <div class="current-events mb-5" >
                <h4 class="t-12 coral-text-color border-buttom-coral no_decoration text-left">Eventi trascorsi</h4>
                {#each passt_events as event }
                    <div style="background:#563f3f; padding: 1rem; margin-top: .5rem; border-radius: .25rem; position:relative;" 
                        in:fade="{{ duration: 200 }}"
                        on:click="{ () => setEvent(event) }"
                        >
                        <h5 class="t-12" style="color:#f4be8b;margin: 0 0 1rem 0;">&#9654; {event.title ? event.title : '' } &#9664;</h5>
                        <div>
                            <p class="t-10" style="font-size:14px; word-break: break-all; ">{event.short_description ? event.short_description : ''}</p>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </div>
    <FloatMenu bind:menu_open="{menu_open}" >
        <div class="float-menu__list-item"> > Profile</div>
    </FloatMenu>

</main>
{/if}